<template>
  <el-form
    label-width="130px"
    :inline="true"
    :model="form"
    class="demo-form-inline"
  >
    <el-form-item label="标题" required>
      <el-input v-model="form.title" placeholder="标题" clearable />
    </el-form-item>
    <el-form-item label="排序" required>
      <el-input v-model="form.sort" placeholder="排序" clearable />
    </el-form-item>
    <el-form-item label="首页展示" required>
      <el-select v-model="form.home_display" placeholder="首页展示" clearable>
        <el-option
          v-for="item in booleanEnums"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="商品发布时间" required>
      <el-date-picker
        v-model="form.product_release_time"
        type="datetime"
        value-format="YYYY-MM-DD HH:mm:ss"
        placeholder="商品发布时间"
        style="width: 100%"
      />
    </el-form-item>
    <!-- <el-form-item label="商品投保时间" required>
      <el-date-picker
        v-model="form.product_insurance_time"
        type="datetime"
        value-format="YYYY-MM-DD HH:mm:ss"
        placeholder="商品投保时间"
        style="width: 100%"
      />
    </el-form-item> -->
    <!-- <el-form-item label="赠送实物产品" prop="gift_goods">
      <el-select v-model="form.gift_goods" placeholder="赠送实物产品" clearable>
        <el-option
          v-for="item in goodsList"
          :label="item.title"
          :key="item.title"
          :value="item.id"
        />
      </el-select>
    </el-form-item> -->
    <el-form-item label="等级收益" required>
      <el-select
        v-model="form.level_income"
        placeholder="首页展示等级收益"
        clearable
      >
        <el-option
          v-for="item in levelIncomeEnums"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="到期赠送现金" required>
      <el-input
        v-model="form.gift_product_expires"
        placeholder="到期赠送现金"
        clearable
      />
    </el-form-item>

    <el-form-item label="状态" required>
      <el-select v-model="form.status" placeholder="状态" clearable>
        <el-option
          v-for="item in saleStatusEnums"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="项目分类" prop="class_id">
      <el-select v-model="form.class_id" placeholder="项目分类" clearable>
        <el-option
          v-for="item in typesEnum"
          :label="item.title"
          :key="item.title"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="可购买的用户等级" prop="level">
      <el-select v-model="form.level" placeholder="可购买的用户等级" clearable>
        <el-option
          v-for="item in levelList"
          :label="item.title"
          :key="item.title"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="虚拟销量" required>
      <el-input v-model="form.sales_fake" placeholder="虚拟销量" clearable />
    </el-form-item>
    <el-form-item label="投资金额" required>
      <el-input v-model="form.invest" placeholder="投资金额" clearable />
    </el-form-item>
    <!-- <el-form-item label="项目总额(万)" required>
      <el-input v-model="form.invest_scale" placeholder="项目总额" clearable />
    </el-form-item> -->
    <el-form-item label="限投次数" required>
      <el-input
        v-model="form.invest_limit"
        placeholder="投资限投次数"
        clearable
      />
    </el-form-item>
    <el-form-item label="收益类型" required>
      <el-select v-model="form.profit_type" placeholder="收益类型" clearable>
        <el-option
          v-for="item in profitTypeEnums"
          :label="item.label"
          :key="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="项目周期" required>
      <el-input v-model="form.profit_cycle" placeholder="项目周期" clearable />
    </el-form-item>
    <el-form-item label="收益倍数" required>
      <el-input v-model="form.profit_more" placeholder="收益倍数" clearable />
    </el-form-item>
    
    <el-form-item label="每期收益率(%)" required>
      <el-input
        v-model="form.profit_rate"
        placeholder="每期收益率(%)"
        clearable
      />
    </el-form-item>
    <el-form-item label="周期时间" required>
      <el-select
        v-model="form.profit_cycle_time"
        placeholder="周期时间"
        clearable
      >
        <el-option
          v-for="item in cycleTimeEnums"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="奖励积分" required>
      <el-input v-model="form.gift_points" placeholder="兑换券" clearable />
    </el-form-item>
    <!-- <el-form-item label="奖励抽奖" required>
      <el-input v-model="form.gift_raffle" placeholder="奖励抽奖" clearable />
    </el-form-item> -->
    <el-form-item label="现金奖励" required>
      <el-input v-model="form.gift_bonus" placeholder="现金奖励" clearable />
    </el-form-item>
    <!-- <el-form-item label="奖励现金券" required>
      <el-input v-model="form.gift_coupon" placeholder="奖励现金券" clearable />
    </el-form-item> -->
    <el-form-item label="新人购买" required>
      <el-select
        v-model="form.is_new"
        placeholder="新人购买"
        clearable
      >
        <el-option
          v-for="item in isNewOptions"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="销售总量" required>
      <el-input v-model="form.sales_all" placeholder="销售总量" clearable />
    </el-form-item>
    <el-form-item label="推三反一奖励" required>
      <el-input v-model="form.gift_push" placeholder="推三反一奖励" clearable />
    </el-form-item>
    <el-form-item label="下级推荐奖励(%)" required>
      <el-input v-model="form.gift_referral_rate" placeholder="下级推荐奖励(%)" clearable />
    </el-form-item>
    <el-form-item label="积分兑换券" required>
      <el-select
        v-model="form.gift_coupon"
        placeholder="新人购买"
        clearable
      >
        <el-option
          v-for="item in isNewOptions"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="项目描述" required>
      <el-input v-model="form.desc" placeholder="项目描述" clearable />
    </el-form-item>
    <!-- <el-form-item label="详情视频" required>
      <el-input v-model="form.video_link" placeholder="详情视频" clearable />
    </el-form-item> -->
    <!-- <el-form-item label="项目进度" required>
      <el-input v-model="form.progress" placeholder="项目进度" clearable />
    </el-form-item> -->
    <!-- <el-form-item label="项目进度更新周期" required>
      <el-select
        v-model="form.progress_cycle"
        placeholder="项目进度更新周期"
        clearable
      >
        <el-option
          v-for="item in cycleTimeEnums"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item> -->
    <!-- <el-form-item label="项目进度更新速率" required>
      <el-input
        v-model="form.progress_rate"
        placeholder="项目进度更新速率"
        clearable
      />
    </el-form-item> -->
    <el-form-item v-if="form.class_id != 1" label="销售限制" required>
      <el-input
        v-model="form.sales_limit"
        placeholder="销售限制"
        clearable
      />
    </el-form-item>
    
    <el-form-item v-if="form.class_id != 1" label="销售时间" required>
      <el-date-picker
        v-model="form.sales_time"
        type="datetime"
        value-format="YYYY-MM-DD HH:mm:ss"
        placeholder="销售时间"
        style="width: 100%"
      />
    </el-form-item>
    <el-form-item label="VIP收益结算" required>
      <el-select
        v-model="form.vip_level_income"
        placeholder="VIP收益结算"
        clearable
      >
        <el-option
          v-for="item in vipLevelIncomeOptions"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item v-if="form.class_id != 1" label="额外获得" required>
      <el-input
        v-model="form.month_extra_profit"
        placeholder="额外获得"
        clearable
      />
    </el-form-item>
    
    <el-form-item label="买一送一" required>
      <el-select v-model="form.gift_free_product" placeholder="选择赠送商品" clearable>
        <el-option
          v-for="item in freeProductList"
          :label="item.title"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="上级返利" required>
      <el-select v-model="form.superior_income" placeholder="选择是否上级返利" clearable>
        <el-option
          v-for="item in superiorIncomeOptions"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="奖励能量" required>
      <el-input
        v-model="form.gift_energy"
        placeholder="奖励能量"
        clearable
      />
    </el-form-item>
    <el-form-item label="奖励周期" required>
      <el-input
        v-model="form.gift_cycle"
        placeholder="奖励周期"
        clearable
      />
    </el-form-item>
    <el-form-item label="周期奖励金额" required>
      <el-input
        v-model="form.gift_cycle_money"
        placeholder="周期奖励金额"
        clearable
      />
    </el-form-item>
    <el-form-item label="递增奖励" required>
      <el-input
        v-model="form.gift_cycle_money_more"
        placeholder="递增奖励"
        clearable
      />
    </el-form-item>
    <el-form-item label="奖励现金券" required>
      <el-input
        v-model="form.gift_cash_coupon"
        placeholder="奖励现金券"
        clearable
      />
    </el-form-item>
    <el-form-item label="奖励加息券%" required>
      <el-input
        v-model="form.gift_rate_coupon"
        placeholder="奖励加息券%"
        clearable
      />
    </el-form-item>
    <!-- <el-form-item label="最小使用金额" required>
      <el-input
        v-model="form.allow"
        placeholder="最小使用金额"
        clearable
      />
    </el-form-item> -->
    <el-form-item label="奖励集字" required>
      <el-select
        v-model="form.gift_words"
        placeholder="请选择奖励集字"
        clearable
      >
        <el-option label="御" value="御" />
        <el-option label="享" value="享" />
        <el-option label="臻" value="臻" />
        <el-option label="品" value="品" />
        <el-option label="行" value="行" />
        <el-option label="稳" value="稳" />
        <el-option label="致" value="致" />
        <el-option label="远" value="远" />
      </el-select>
    </el-form-item>
    <el-form-item label="是否能量产品" required>
      <el-select
        v-model="form.is_energy"
        placeholder="请选择是否能量产品"
        clearable
      >
        <el-option label="是" :value="1" />
        <el-option label="否" :value="0" />
      </el-select>
    </el-form-item>
    <el-form-item
      label="项目图片"
      prop="img"
      :rules="[{ required: true, message: '请上传图片' }]"
    >
      <el-upload
        class="upload-demo"
        style="width: 114px"
        :show-file-list="false"
        drag
        :headers="headers"
        :action="`${proxy.BASE_API_URL}index/upload`"
        :on-success="successUpload"
        :on-error="handleErr"
        :multiple="false"
      >
        <img
          v-if="form.img"
          :src="proxy.IMG_BASE_URL + form.img"
          width="100%"
          class="avatar" />
        <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon
      ></el-upload>
    </el-form-item>

    <div style="border: 1px solid #ccc">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editorRef"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />
      <Editor
        style="height: 500px; overflow-y: hidden"
        v-model="form.content"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="handleCreated"
      />
    </div>
  </el-form>
</template>

<script setup>
import { htmlDecodeByRegExp } from "@/utils/utils";
import {
  rolesEnums,
  profitTypeEnums,
  levelIncomeEnums,
  profitTypeBEnums,
  saleStatusEnums,
  cycleTimeEnums,
  booleanEnums,
  vipLevelIncomeOptions,
  superiorIncomeOptions
} from "@/config/enums";
import {
  onBeforeUnmount,
  nextTick,
  ref,
  shallowRef,
  onMounted,
  getCurrentInstance,
} from "vue";
import { getTokenAUTH } from "@/utils/auth";

const form = ref({
  title: "",
  img: "",
  status: "",
  sort: "",
  home_display: "",
  product_release_time: "",
  product_insurance_time: "",
  gift_goods: "",
  level_income: "",
  gift_product_expires: "",
  level: "",
  class_id: "",
  sales_fake: "",
  invest: "",
  invest_scale: "",
  invest_limit: "",
  profit_type: "",
  profit_rate: "",
  profit_more: "",
  profit_cycle: "",
  profit_cycle_time: "",
  gift_points: "",
  gift_raffle: "",
  gift_bonus: "",
  content: "",
  desc: "",
  video_link: "",
  progress: "",
  progress_cycle: "",
  progress_rate: "",
  sales_time: "",
  sales_limit: "",
  is_new: 0,
  sales_all: "",
  gift_coupon: 0,
  gift_push: "",
  vip_level_income: "",
  month_extra_profit: 0,
  gift_referral_rate: "",
  gift_free_product: "",
  superior_income: "",
  gift_energy: "",
  gift_cycle: "",
  gift_cycle_money: "",
  gift_cycle_money_more: "",
  gift_cash_coupon: "",
  gift_rate_coupon: "",
  gift_words: "",
  is_energy: 0,
  // allow: "",
  // gift_coupon: "",
  // coupon_limit: "",
});
const isNewOptions = ref([
  {
    value: 0,
    label: '关闭'
  },
  {
    value: 1,
    label: '开启'
  }
])
const props = defineProps(["item"]);

const headers = ref({});
onMounted(() => {
  headers.value["Accept-Token"] = getTokenAUTH();
  nextTick(() => {
    props.item.content = props.item.content ? htmlDecodeByRegExp(props.item.content) : "";
    form.value = Object.assign(form.value, props.item);
  });
  getTYpesEnum();
  getLevelList();
  getGoodsList();
  getFreeProductList();
});

const { proxy } = getCurrentInstance();

const levelList = ref([]);
const getLevelList = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/Level/getLevelLists",
  });
  if (res.code == 0) {
    levelList.value = [{ title: "普通会员", id: 0 }, ...res.data.data];
  }
};

const goodsList = ref([]);
const freeProductList = ref([]);

const getGoodsList = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/Goods/getGoodsLists",
    params: {
      page: 1,
      limit: 999,
    },
  });

  if (res.code == 0) {
    goodsList.value = res.data.data || [];
  }
};

const getFreeProductList = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/Item/getItemLists",
    params: {
      page: 1,
      limit: 999,
    },
  });
  if (res.code == 0) {
    const list = res.data.data || [];
    const currentId = props.item && props.item.id ? props.item.id : form.value.id;
    freeProductList.value = list.filter((p) => p.id !== currentId);
    if (form.value.gift_free_product && form.value.gift_free_product === currentId) {
      form.value.gift_free_product = "";
    }
  }
};
const typesEnum = ref([]);

const getTYpesEnum = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/Item/getItemClassLists",
  });
  if (res.code == 0) {
    typesEnum.value = res.data.data;
  }
};

const successUpload = (res) => {
  form.value.img = res.data.url;
};

const handleErr = (err) => {
  if (err.status == 320) {
    form.value.img = JSON.parse(err.message).data.url;
  }
};

// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef();

// 内容 HTML
const valueHtml = ref("<p>hello</p>");
const mode = ref("default");

const toolbarConfig = {};
const editorConfig = {
  placeholder: "请输入内容...",
  MENU_CONF: {
    uploadImage: {
      fieldName: "file",
      maxFileSize: 10 * 1024 * 1024, // 10M
      server: proxy.BASE_API_URL + "index/uploadX",
      headers: {
        "Accept-Token": getTokenAUTH(),
      },
      customInsert(res, insertFn) {
        // 如果后端返回的URL已经包含http或https协议，直接使用
        // 否则拼接IMG_BASE_URL
        let url = res.data.url;
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = proxy.IMG_BASE_URL + url;
        } else {
          // 如果是http开头，替换为https
          url = url.replace('http://', 'https://');
        }
        const alt = res.data.alt;
        const href = res.data.href;
        insertFn(url, alt, href);
      },
    },
  },
};

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
});

const handleCreated = (editor) => {
  editorRef.value = editor; // 记录 editor 实例，重要！
};

defineExpose({ form });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}

.demo-form-inline .el-input {
  --el-input-width: 220px;
}

.demo-form-inline .el-select {
  --el-select-width: 220px;
}

/deep/ .el-radio-group {
  width: 220px;
}

.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}

/deep/ .el-form-item {
  align-items: flex-start;
}
</style>
